import React from "react";
import "./thesis.css";
import Comparison from "./image/comparison.png";
import Convergence from "./image/convergence.png";
import Brutnet from "./image/brutnet.png";
import { width } from "@fortawesome/free-brands-svg-icons/fa42Group";
import conceptual from "./image/conceptual.png";

export default function BachelorThesisBody() {
  return (
    <div className="bachelor-thesis-body">
      <h2 className="thesis-title">
        Title: Detection and Classification of Sensitive Audio-Visual Content for Automated Film Censorship and Rating

      </h2>

      <p className="thesis-supervisor">
        <b>Supervisor:</b> Lieutenant Colonel Hussain Md. Abu Nyeem, PhD
      </p>

      <p className="thesis-abstract" style={{textAlign: 'justify'}}>
        <b>Abstract:</b> Automatic Film Censorship and Rating (AFCR) has recently emerged as a significant Machine Learning (ML) research area. The increased production and distribution of audio-visual content complicates manual censorship and rating. Thus, ML-based AFCR design methods have emerged. To begin, a “complete” conceptual model of the system must be developed, complete with potential classes and their associated criteria. This paper aims to standardise the AFCR system criteria. Comparing existing ML models showed the effectiveness of sequential and multimodal analysis in developing an efficient AFCR system. This article also discusses BrutNet, a new Deep Convolutional Neural Network (DCNN) model for detecting violence. Gated Recurrent Unit (GRU) operates to determine the patterns across multiple video frames or video clips of shape of 160 x 90 and a duration of 3 seconds or more. To obtain the image feature-set and pattern, each frame of the time-distributed layer was considered. The DCNN layers reduces data from four dimensions to two and obtains 512 features per frame. The obtained features are passed to GRU layer which generates one-dimensional vector which is then processed through several dense layers. As a result, the content is classified as violent or non-violent in the output node. The hidden and output layers had ReLu and sigmoid activation functions. The model was trained on an NVIDIA Tesla K80 GPU at Google Colab. The trained model outperformed the previous LSTM-based ResNet50 model, with a test accuracy of 90%.
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
  <div style={{ flex: 1}}>
    <img src={conceptual} alt="Conceptual Model" style={{ width: '100%', maxWidth: '400px', height: '400px'

    }} />
    <p className="result-caption">Fig 1: Conceptual model of the proposed AFCR system.</p>
  </div>
  <div style={{ flex: 2 }}>
    <img src={Brutnet} alt="BrutNet Architecture" style={{ width: '100%', maxWidth: '2500px', height:"400px" }} />
    <p className="result-caption">Fig 2: Architecture of BrutNet.</p>
  </div>
</div>

      <div className="thesis-results">
        <h3 className="results-title">Results</h3>
       <p style={{fontSize:18}}> In this work, our proposed BrutNet model, which integrates DCNN and GRU layers, achieved a test accuracy of 90.00% and a low false-positive rate of 7.23%. The system demonstrated significant improvements in classifying violent and non-violent scenes compared to previous LSTM-based ResNet50 approaches. Convergence trends and visual output examples validate the model’s robustness and reliability in detecting sensitive audio-visual content. These results underscore the potential of our automated system for efficient film censorship and rating.</p>
        <br/> <br/> <br/>
        <div className="results-grid">
            <div className="result-item">
            <img src={Comparison} alt="Comparison between State-of-the-art and ours" />
            <p className="result-caption">Fig 3: Comparison of classification accuracy of BrutNet (ours) and State-of-the-art.</p>
            </div>
            <div className="result-item">
            <img src={Convergence} alt="Convergence Trends" />
            <p className="result-caption">Fig 4: Convergence trends: accuracy, loss, F1-score, false positive rate.</p>
            </div>
            {/* <div className="result-item">
            <img src="/path/to/figur" alt="Correctly Classified Frames" />
            <p className="result-caption">Examples of correctly classified frames.</p>
            </div>
            <div className="result-item">
            <img src="/path/to/figure4_5.png" alt="Erroneous Outputs" />
            <p className="result-caption">Examples of erroneous output frames.</p>
            </div> */}
        </div>
        </div>


      <div className="thesis-download">
        <a
          href="https://drive.google.com/file/d/1iodasooWQm7byxUi0sDEPDTlwg1QfF6K/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download Thesis Book (PDF)
        </a>
      </div>

      <div className="thesis-researchgate">
        <a
          href="https://www.researchgate.net/publication/359704298_Detection_and_Classification_of_Sensitive_Audio-Visual_Content_for_Automated_Film_Censorship_and_Rating?channel=doi&linkId=6249a3aa8068956f3c668be5&showFulltext=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          View on ResearchGate
        </a>
      </div>

      <div className="thesis-pdf-preview">
      <iframe
  src="https://drive.google.com/file/d/1iodasooWQm7byxUi0sDEPDTlwg1QfF6K/preview"
  width="100%"
  height="100%"
  title="Thesis Book Preview"
></iframe>

      </div>
    </div>
  );
}
